module.exports = __webpack_public_path__ + "img/44.c61c167d.svg";